<script lang="ts" setup>
import { ref, defineExpose } from 'vue'

// 发送消息消息事件
const emit = defineEmits<{
  send: [message: string],
  abort:any,
  setMode:[knowledgeQuery:Boolean],
}>()

//设置属性
const props = defineProps({
  senMessageEnable: { type: Boolean ,deault: true ,required: true},
})

// 输入框内的消息
const messageText = ref('')
//是否为知识查询模式
const knowledgeQuery = ref(true);

const popoverRef = ref({} as any);
const messageInputRef = ref({} as any);

//向父组件暴露
defineExpose({messageInputRef});

//处理回车事件，实现换行和发送消息
const handleKeydownEnter = (event: KeyboardEvent) => {
    event.preventDefault();
    if (event.ctrlKey || event.shiftKey) {
      messageText.value += '\n'; // 插入换行符
    }
    else{
      sendMessage();
    }
}

const sendMessage = () => {
  var messageTrim:string = messageText.value.trim();
    if(messageTrim.length > 0 && props.senMessageEnable)
    {
        emit('send', messageText.value)
        // 发送完清除
        messageText.value = ''
    }
}

const setKnowledgeQuery = (value:boolean)=>{
  knowledgeQuery.value = value;
  
  if(popoverRef.value)
  {
    popoverRef.value.hide();
  }
  emit('setMode',knowledgeQuery.value);
}

const abortMessage = () => {
    emit('abort');    
}
</script>

<template>
  <div class="message-input">
    <div class="input-wrapper">
      <!-- 按回车键发送，输入框高度三行 -->
      <el-input
        v-model="messageText"
        ref="messageInputRef"
        id="messageInputId"
        :autosize="false"
        :rows="3"
        class="input"
        resize="none"
        type="textarea"
        :placeholder="$t('input.preWorld')"
        @keydown.enter="handleKeydownEnter"
      >
      </el-input>
      <div class="button-wrapper">

        <el-button v-if="senMessageEnable" class="send-button"  icon="el-icon-send" @click="sendMessage" :disabled="!messageText.trim()">
          <i class="el-icon-send">
            <span class="icon-content">c</span>
          </i>
        </el-button>
        <el-button v-else  class="abort-button" icon="el-icon-abort" @click="abortMessage" >
          <i class="el-icon-abort">
            <span class="icon-content">c</span>
          </i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/_handle.scss";

.input-wrapper
{
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  justify-content: flex-end;
}

.input
{
  flex-grow: 1;
  :deep(.el-textarea__inner) 
  {
    box-shadow: 0 0 0 0px ;
    font-size: 15px;
    @include font_color("font-color");
    font-weight:500;
    background-color: inherit;
    overflow: auto;
    ::placeholder
    {
      font-size: 15px;
      @include font_color("place-hoder");
    }
  }
}

.button-wrapper 
{
  margin-top: 10px;
  margin-bottom: 10px;
  width: 60px;
  min-width: 60px;
  margin-right: 10px;
  margin-left: 10px;
  border-left: 2px solid rgb(255, 255, 255);
  display:flex;
  flex-direction: column;
  justify-content: center;
}

.icon-content
{
    visibility: hidden;
}

.el-icon-send
{
  display:flex;
  width:24px;
  height:24px;
  @include background_image("send-button-img");
  background-size:100% 100%;
  margin-right: 10px;
}

.el-icon-abort
{
  display:flex;
  width:30px;
  height:30px;
  @include background_image("abort-button-img");
  background-size:100% 100%;
  margin-right: 10px;
  margin-top: -5px;
}

.el-icon-mode-query
{
  display:flex;
  width:16px;
  height:16px;
  @include background_image("mode-query-button-img");
  background-size:100% 100%;
  margin-right: 10px;
  margin-top: -7px;
}

.el-icon-mode-api
{
  display:flex;
  width:16px;
  height:16px;
  @include background_image("mode-api-button-img");
  background-size:100% 100%;
  margin-right: 10px;
  margin-top: -7px;
}

.mode-button
{
  @include background_color("sidebar-background");
  border-radius: 10px;
  border:0px;
  height: 20px;
  margin-left:10px;
  margin-bottom: 5px;
}

.send-button 
{
  background-color:inherit;
  margin-left:10px!important;
  border: 0;
  cursor:default; 
}

.send-button:hover 
{    
    background-color:inherit;
    margin-left:10px!important;
    border: 0;
    cursor:pointer; 
}

.send-button[disabled] 
{
  background-color:inherit;
  margin-left:10px!important;
  cursor:default; 
}

.send-button[disabled]:hover 
{
  background-color:inherit;
  margin-left:10px!important;
  cursor:default; 
}


.abort-button 
{
  border:0px;
  background-color:inherit;
  margin-left:10px!important;
  cursor:pointer; 
}

.abort-button:hover 
{
  border:0px;
  background-color:inherit;
  margin-left:10px!important;
  cursor:pointer; 
}

</style>



<style lang="scss">
@import "@/style/_handle.scss";

//点击“更多”按钮后菜单样式
.mode-popover
{
  min-width: 120px!important;
  width: 142px!important;
  border-color:rgb(170,170,170)!important;
  @include background_color("sidebar-background");

  .el-popper__arrow::before
  {
    @include background_color("sidebar-background");
    border-color:rgb(170,170,170)!important;
  }
  
  .mode-manu
  {
    width: 135px;
    height: 100%;
    margin:-10px;
    background-color: inherit;

    display: flex;
    flex-direction: column;
  }

  .el-button + .el-button{
    margin: 0px;
  }

  .query-button 
  {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    font-size: 15px;
    padding-top: 5px;
    padding-bottom: 20px;
    background-color:inherit;
    @include font_color("font-color");
    border: 0;
    cursor:pointer; 
  }

  .query-button:hover 
  {    
    @include background_color("mask-color");
    @include font_color("font-color");
    cursor:pointer; 
  } 
  
  .api-button 
  {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-left: -12px;
    margin-right: 0px;
    padding-top: 5px;
    padding-bottom: 20px;
    font-size: 15px;
    background-color:inherit;
    @include font_color("font-color");
    border: 0;
    cursor:pointer; 
  }

  .api-button:hover 
  {    
    @include font_color("font-color");
    @include background_color("mask-color");
    cursor:pointer; 
  }   


  .icon-content
  {
      visibility: hidden;
  }

  .el-icon-query
  {
    display:flex;
    width:24px;
    height:24px;
    @include background_image("query-button-img");
    background-size:100% 100%;
    margin-right: 10px;
  }

  .el-icon-api
  {
    display:flex;
    width:24px;
    height:24px;
    @include background_image("api-button-img");
    background-size:100% 100%;
    margin-right: 10px;
  }
}
</style>
